import $ from 'jquery';
import { SEARCH_DEFAULT_RESULT } from '@/js/modules/selectize_plugins';
import debounce from '@/js/util/debounce';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on(
    'keyup paste change',
    '.field--generate-purchase-orders-search, .field--generate-purchase-orders-vendor-list',
    () => {
      filterGeneratePurchaseOrdersVendors();
    }
  );

  function undoMerge() {
    $('.generate-purchase-orders-vendor__undo-merge').hide();

    $('.generate-purchase-orders-vendor--merged')
      .removeClass('generate-purchase-orders-vendor--merged')
      .removeClass('hide');

    $('.generate-purchase-orders-vendor__merged-qty').text('');

    $('.generate-purchase-orders-vendor__merged-products-qty').hide();
    $('.generate-purchase-orders-vendor__real-products-qty').show();

    $('.generate-purchase-orders-vendor__merged-subtotal').hide();
    $('.generate-purchase-orders-vendor__real-subtotal').show();

    $('#vendors_to_merge').val('');
  }

  function filterGeneratePurchaseOrdersVendors() {
    undoMerge();
    const searchQuery = $('.field--generate-purchase-orders-search').val().toLowerCase();
    const vendor = $('.field--generate-purchase-orders-vendor-list').val();

    $('.checkbox--generate-purchase-orders-check-all').prop('checked', false);
    $('.checkbox--generate-purchase-orders').prop('checked', false);
    $('.p-button--generate-purchase-orders').prop('disabled', true);
    $('.p-button--generate-purchase-orders__text').text('');

    $('.generate-purchase-orders-vendor').each((_, e) => {
      const $vendor = $(e);

      const hideVendor =
        !$vendor.text().toLowerCase().includes(searchQuery.toLowerCase()) ||
        (vendor.length && $vendor.data().vendor !== vendor);

      if (hideVendor) {
        $vendor.addClass('hide');
      } else {
        $vendor.removeClass('hide');
      }
    });
  }

  function initializeVendorDropdown(element, options) {
    const selectized = element.selectize;
    options.forEach((option) => {
      selectized.addOption(option);
      if (option.selected) {
        selectized.addItem(option.company_name, true);
      }
    });
    element.dataset.initialized = true;
  }

  $(document).on('change', '.checkbox--generate-purchase-orders-check-all', (e) => {
    $(
      '.generate-purchase-orders-vendor[data-vendor]:visible:not([disabled]) .checkbox--generate-purchase-orders:not([disabled])'
    )
      .prop('checked', $(e.target).is(':checked'))
      .change();
  });

  function updateGeneratePOModalControls() {
    const selectedCheckboxes = $(
      '.generate-purchase-orders-vendor[data-vendor]:visible .checkbox--generate-purchase-orders:checked'
    ).length;

    if (selectedCheckboxes) {
      $('.p-button--generate-purchase-orders').prop('disabled', false);
      $('.p-button--generate-purchase-orders__text').text(`(${selectedCheckboxes})`);
    } else {
      $('.p-button--generate-purchase-orders').prop('disabled', true);
      $('.p-button--generate-purchase-orders__text').text('');
    }

    if (selectedCheckboxes > 1) {
      $('.h-s-button--merge-vendors').prop('disabled', false);
    } else {
      $('.h-s-button--merge-vendors').prop('disabled', true);
    }

    $('.checkbox--generate-purchase-orders-check-all').prop(
      'checked',
      selectedCheckboxes === $('.generate-purchase-orders-vendor[data-vendor]:visible').length
    );

    const $addMissingVendorsLink = $('.add-missing-vendors-link');
    if ($addMissingVendorsLink.length) {
      const selectedVendors = $('.checkbox--generate-purchase-orders:checked')
        .map((_, e) => $(e).val())
        .get();

      let url = $addMissingVendorsLink.prop('href').split('&')[0];
      if (selectedVendors.length) {
        url = url + '?selected=' + encodeURIComponent(JSON.stringify(selectedVendors));
      }
      $addMissingVendorsLink.prop('href', url);
    }
  }

  $(document).on('change', '.checkbox--generate-purchase-orders', () => {
    updateGeneratePOModalControls();

    return false;
  });

  $(document).on('click', '.h-s-button--merge-vendors', () => {
    const $trs = $(
      '.generate-purchase-orders-vendor[data-vendor]:visible .checkbox--generate-purchase-orders:checked'
    ).map((_, el) => {
      return $(el).closest('.generate-purchase-orders-vendor');
    });

    $trs.each((index, tr) => {
      $(tr).addClass('generate-purchase-orders-vendor--merged');
      if (index > 0) {
        $(tr).addClass('hide');
      }
    });

    let mergedProductsQty = 0;
    let mergedSubtotal = 0;
    const vendorsToMerge = [];
    $('.generate-purchase-orders-vendor--merged').each((_, tr) => {
      vendorsToMerge.push($(tr).data().vendor);
      mergedProductsQty += parseInt(
        $(tr).find('.generate-purchase-orders-vendor__real-products-qty').text()
      );
      mergedSubtotal += parseFloat(
        $(tr)
          .find('.generate-purchase-orders-vendor__real-subtotal')
          .text()
          .replace(/[^0-9.]/g, '')
      );
    });
    $('#vendors_to_merge').val(JSON.stringify(vendorsToMerge));

    const $mainTr = $($trs[0]);

    $mainTr
      .find('.generate-purchase-orders-vendor__merged-qty')
      .text(`(${$('.generate-purchase-orders-vendor--merged').length})`);
    $mainTr.find('.generate-purchase-orders-vendor__undo-merge').css('display', 'inline-block');
    $mainTr
      .find('.generate-purchase-orders-vendor__merged-products-qty')
      .text(mergedProductsQty)
      .show();

    const currencySymbol = $('meta[name="currency-symbol"]').attr('content');
    $mainTr.find('.generate-purchase-orders-vendor__real-products-qty').hide();
    $mainTr
      .find('.generate-purchase-orders-vendor__merged-subtotal')
      .text(`${currencySymbol}${mergedSubtotal.toFixed(2)}`)
      .show();
    $mainTr.find('.generate-purchase-orders-vendor__real-subtotal').hide();

    const selectedCheckboxes = $(
      '.generate-purchase-orders-vendor[data-vendor]:visible .checkbox--generate-purchase-orders:checked'
    ).length;
    $('.p-button--generate-purchase-orders__text').text(`(${selectedCheckboxes})`);

    $('.h-s-button--merge-vendors').prop('disabled', true);

    return false;
  });

  $(document).on('click', '.generate-purchase-orders-vendor__undo-merge', () => {
    filterGeneratePurchaseOrdersVendors();

    return false;
  });

  $(document).on($.modal.OPEN, '.modal--generate-purchase-orders', () => {
    $('.modal--generate-purchase-orders').each(function () {
      if (!this.closest('.jquery-modal.blocker.current')) {
        this.remove();
      }
    });

    updateGeneratePOModalControls();

    const $vendorDropdownSelectizedEl = $(
      '.selectize-control--vendor-dropdown[data-initialized=false]'
    );
    if ($vendorDropdownSelectizedEl.length > 0) {
      $vendorDropdownSelectizedEl.selectize({
        plugins: [SEARCH_DEFAULT_RESULT],
        persist: true,
        placeholder: 'Select a Vendor',
        valueField: 'company_name',
        labelField: 'company_name',
        searchField: ['company_name'],
        maxItems: 1,
        render: {
          option(item, escape) {
            if (item.newVendor) {
              return `<div class="selectize-dropdown-content__add-vendor">${escape(
                item.label
              )}</div>`;
            } else {
              const safeCompanyName = escape(item.company_name);
              return `<div class="suggested_vendor__profile">
              <div class="suggested_vendor__avatar suggested_vendor__avatar--no-image">
                ${escape(item.initials)}
              </div>
                ${safeCompanyName}
              </div>
            `;
            }
          },
          item(item, escape) {
            return `<div class="item">${escape(item.company_name)}</div>`;
          },
        },
        onChange(value) {
          if (!value) {
            return;
          }

          const select = this.$input[0];
          const wrapper = this.$wrapper[0];
          const cell = wrapper.closest('td');
          const row = cell.closest('tr');
          const url = select.dataset.url;
          const vendor = select.value;
          const billableItemIds = row.dataset.billableItemIds.split('-');
          const checkboxCell = row.querySelector('td');
          const mergeCheckbox = checkboxCell.querySelector('.checkbox--generate-purchase-orders');

          $.post(url, { billable_item_ids: billableItemIds, vendor }, () => {
            wrapper.style.display = 'none';
            cell.querySelector('.generate-purchase-orders-vendor__vendor-not-found').style.display =
              'none';
            cell.querySelector('.generate-purchase-orders-vendor__name').innerHTML = `
            ${value}
            <span class="generate-purchase-orders-vendor__merged-qty"></span>
          `;
            mergeCheckbox.value = value;
            mergeCheckbox.disabled = false;
            mergeCheckbox.labels[0].removeAttribute('title');
          }).fail(() => {
            console.error(`Could not update items ${billableItemIds.join(',')}`);
          });
        },
        onDropdownOpen($dropdown) {
          // clean previous search term highlighting
          $dropdown.find('span.highlight').each(function () {
            const text = $(this).text();
            $(this).replaceWith(text);
          });

          $dropdown.find('[data-value="new"]').removeAttr('data-selectable');
          $dropdown.find('[data-value="new"]').attr('data-new-vendor', '');
        },
        onDropdownClose($dropdown) {
          const newVendorOption = $dropdown.find('[data-value="new"]')[0];

          if (newVendorOption) {
            newVendorOption.textContent = 'Add New Vendor';
          }

          // clean previous search term highlighting
          $dropdown.find('span.highlight').each(function () {
            const text = $(this).text();
            $(this).replaceWith(text);
          });
        },
        onItemAdd(value, $item) {
          if (this.isFocused) {
            this.$input.trigger('selectizeVendor:added', [value, $item]);
          }
        },
      });

      $vendorDropdownSelectizedEl.each((_, element) => {
        initializeVendorDropdown(element, $vendorDropdownSelectizedEl.data().options);
      });

      $('.selectize-input input').on(
        'keyup',
        debounce(function (event) {
          $('.selectize-dropdown-content__add-vendor').html(
            `Add ${event.target.value} as a New Vendor`
          );
        }, 200)
      );
    }
  });

  $(document).on($.modal.OPEN, '.modal--assign-missing-vendors', () => {
    $('.modal--assign-missing-vendors').each(function () {
      if (!this.closest('.jquery-modal.blocker.current')) {
        this.remove();
      }
    });

    const $vendorDropdownSelectizedEl = $(
      '.selectize-control--vendor-dropdown[data-initialized=false]'
    );
    if ($vendorDropdownSelectizedEl.length > 0) {
      $vendorDropdownSelectizedEl.selectize({
        plugins: [SEARCH_DEFAULT_RESULT],
        persist: true,
        placeholder: 'Select a Vendor',
        valueField: 'company_name',
        labelField: 'company_name',
        searchField: ['company_name'],
        maxItems: 1,
        render: {
          option(item, escape) {
            if (item.newVendor) {
              return `<div class="selectize-dropdown-content__add-vendor">${escape(
                item.label
              )}</div>`;
            } else {
              const safeCompanyName = escape(item.company_name);
              return `<div class="suggested_vendor__profile">
              <div class="suggested_vendor__avatar suggested_vendor__avatar--no-image">
                ${escape(item.initials)}
              </div>
                ${safeCompanyName}
              </div>
            `;
            }
          },
          item(item, escape) {
            return `<div class="item">${escape(item.company_name)}</div>`;
          },
        },
        onDropdownOpen($dropdown) {
          // clean previous search term highlighting
          $dropdown.find('span.highlight').each(function () {
            const text = $(this).text();
            $(this).replaceWith(text);
          });

          $dropdown.find('[data-value="new"]').removeAttr('data-selectable');
          $dropdown.find('[data-value="new"]').attr('data-new-vendor', '');
        },
        onDropdownClose($dropdown) {
          const newVendorOption = $dropdown.find('[data-value="new"]')[0];

          if (newVendorOption) {
            newVendorOption.textContent = 'Add New Vendor';
          }

          // clean previous search term highlighting
          $dropdown.find('span.highlight').each(function () {
            const text = $(this).text();
            $(this).replaceWith(text);
          });
        },
        onItemAdd(value, $item) {
          if (this.isFocused) {
            this.$input.trigger('selectizeVendor:added', [value, $item]);
          }
        },
      });

      $vendorDropdownSelectizedEl.each((_, element) => {
        initializeVendorDropdown(element, $vendorDropdownSelectizedEl.data().options);
      });

      $('.selectize-input input').on(
        'keyup',
        debounce(function (event) {
          $('.selectize-dropdown-content__add-vendor').html(
            `Add ${event.target.value} as a New Vendor`
          );
        }, 200)
      );
    }
  });

  $(document).on('mousedown', '.selectize-dropdown-content__add-vendor', (e) => {
    const row = e.target.closest('tr[data-billable-item-ids]');
    const billableItemIds = row.dataset.billableItemIds;
    const newCompanyName = row.querySelector('div.selectize-control--vendor-dropdown input').value;
    const url = `/vendors/new?kind=billable&billable_item_ids=${billableItemIds}&new_company_name=${newCompanyName}`;

    $.get(url).done((data) => {
      e.target.closest('.modal').dataset.currentModal = '';
      $(data).modal();
    });
  });

  $(document).on('submit', '.vendors-form--billable', (e) => {
    e.preventDefault();
    const $form = $(e.target);
    const billableItemIds = $form.find('#billable_item_ids').val();
    const $submitButton = $form.find('.p-button--vendors-form');

    $submitButton.addClass('button-loading').prop('disabled', true);

    const $validationUrl = $submitButton.data().validationUrl;
    $.post($validationUrl, $form.serialize().replace('_method=patch', '_method=post')).done(
      (res) => {
        if (res.valid) {
          $.post(
            $form.attr('action'),
            $form.serialize(),
            (data) => {
              $('.modal--vendor-form .close-modal').click();
              $('.modal[data-current-modal]').modal('show');
              $('.modal[data-current-modal]').removeAttr('data-current-modal');

              const selectized = document.querySelector(
                `select.selectize-control--vendor-dropdown[data-billable-item-ids='${billableItemIds}']`
              ).selectize;
              const initials = data.company_name
                .split(' ')
                .slice(0, 2)
                .map((word) => word[0])
                .join('')
                .toUpperCase();
              const newOption = { id: data.id, company_name: data.company_name, initials };
              newOption.$order = selectized.order - 1;

              document
                .querySelectorAll('select.selectize-control--vendor-dropdown')
                .forEach(({ selectize }) => {
                  selectize.addOption(newOption);
                });
              selectized.addItem(data.company_name);
            },
            'json'
          );
        } else {
          for (const key of Object.keys(res.errors)) {
            $form
              .find(`.error-message--vendor-form-${key.replace('_', '-')}`)
              .text([key.replace('_', ' '), res.errors[key].join(' and ')].join(' '))
              .show();
          }
          $submitButton.removeClass('button-loading').prop('disabled', false);
        }
      }
    );
  });

  $(document).on($.modal.CLOSE, '.modal--assign-missing-vendors', () => {
    $('.modal--generate-purchase-orders').modal();
  });

  $(document).on('submit', '[data-generate-purchase-orders-form]', () => {
    $('.p-button--generate-purchase-orders').prop('disabled', true);
  });
});
